import { render, staticRenderFns } from "./GroupMessage.vue?vue&type=template&id=70ba4226&scoped=true&"
import script from "./GroupMessage.vue?vue&type=script&lang=ts&"
export * from "./GroupMessage.vue?vue&type=script&lang=ts&"
import style0 from "./GroupMessage.vue?vue&type=style&index=0&id=70ba4226&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.4.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70ba4226",
  null
  
)

component.options.__file = "GroupMessage.vue"
export default component.exports